"use client";

import { useInfoCenter } from "@/api/hook/use-info-center";
import { InfoCard } from "./info-card";
import Link from "next/link";

export const InfoCenterSection = ({ facId }: { facId?: string }) => {
  const { data, imageUrls, loading, error } = useInfoCenter();

  if (loading) {
    return null;
  }

  if (error) {
    return (
      <div className="text-center py-12 text-gray-500">
        <p>Unable to load information center data</p>
      </div>
    );
  }

  const allItems = Object.entries(data).flatMap(([type, items]) =>
    items.map((item) => ({
      ...item,
      type,
    })),
  );

  if (allItems.length === 0) {
    return null;
  }

  const displayedItems = allItems.slice(0, 3);
  return (
    <section className="container mx-auto px-4">
      <div className="flex flex-col gap-8">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-2">
            Information Center
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Stay updated with the latest news, vacancies, events, and
            announcements
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayedItems.map((item) => (
            <InfoCard
              key={item.id}
              id={item.id}
              facId={facId}
              infoType={item.type}
              title={item.infoMaterial.replace(/<[^>]*>/g, "").substring(0, 60)}
              description={item.infoMaterial}
              imageUrl={imageUrls[item.id]}
            />
          ))}
        </div>

        {allItems.length > 3 && (
          <div className="flex justify-center mt-4">
            <Link
              href={
                facId ? `/membership-site/${facId}/info-center` : `/info-center`
              }
            >
              <button className="px-8 py-3 bg-primary text-[#FFF] rounded-md hover:bg-primary/90 transition-colors duration-200 font-medium">
                View All
              </button>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};
